import React from 'react';
import classNames from 'classnames';

export default function CustomerView({
  customer,
  className
}: {
  customer: string;
  className?: string;
}) {
  return (
    <>
      <span
        className={classNames('fw-semi-bold ms-1', className || 'text-primary')}
      >
        {' '}
        {customer}
      </span>
    </>
  );
}
